export enum BankName {
  DEV = 1,
  SHORE = 2,
  CBT = 3,
  INB = 5,
  HERRING = 7,
  TRANSACT = 8,
  CHAMPION = 9,
  FLAGLER = 12,
  VALLIANCE = 13,
  BISON = 14
}

export enum BankNames {
  DEV = 'Dev Bank'
}
